import { Point, Range } from 'slate';

/**
 * A range Slate keeps in sync as the document changes. `current` is null once the text is gone.
 * The real value is a Slate `RangeRef`; tests may pass `{ current: range }`.
 */
export interface SpellcheckRangeRef {
  readonly current: Range | null;
}

/** `null` hides every redline in the paragraph. A point hides from that point onward. */
export type SpellcheckRetiredFrom = Point | null;

export function isSpellcheckRedlineHidden(
  range: Range,
  retiredFrom: SpellcheckRetiredFrom | undefined
): boolean {
  if (retiredFrom === undefined) return false;
  if (retiredFrom === null) return true;
  return !Point.isBefore(Range.end(range), retiredFrom);
}
